export default "__VITE_ASSET__bd7a2f3a__"